import { render, staticRenderFns } from "./SummedRating.vue?vue&type=template&id=77a17a25&scoped=true"
import script from "./SummedRating.vue?vue&type=script&lang=ts"
export * from "./SummedRating.vue?vue&type=script&lang=ts"
import style0 from "./SummedRating.vue?vue&type=style&index=0&id=77a17a25&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a17a25",
  null
  
)

export default component.exports